import { makeQuery } from 'shared/utilities';
import { CalendarItemModel, ICalendarItemModel } from "shared/models";

type RequestType = CalendarItemModel;

type ResponseType = {
    item: ICalendarItemModel;
};

export const calendarItemsSaveQuery = async function (data: RequestType) {
    return await makeQuery<ResponseType>('/calendar-items/save', { json: data });
}
